// extracted by mini-css-extract-plugin
module.exports = {"loader":"Map_loader__3Qroo","root":"Map_root__1V4ah","mapRoot":"Map_mapRoot__1LXKA"};